import { useAuthStore, withAuthStore } from 'context/AuthStore'
import { useResErrors, useRoutes, useStateCallback } from 'hooks'
import { createContext, useEffect, useRef, useState } from 'react'
import TaskStoreProviderManager from 'context/HomeStore/Manager/TaskProvider/TaskProvider.manager'
import SelectionStoreProviderManager from 'context/HomeStore/Manager/SelectionProvider/SelectionProvider.manager'
import WorkListStoreProviderManager from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { AuthService, SalesService } from 'lib/api'
import { NEW_SEO, SELECTION_STEP_PATH_LOADED } from 'routes/constants.routes'
import { getPrevStepByStatus } from 'constants/deals'
import BonusStoreProviderManager from './BonusProvider/BonusProvider.manager'
import { MANAGER_AUTO_DAMU } from 'constants/roles'

export const HomeStoreContext = createContext({
  homeStore: {},
  homeStoreFunc: {}
})

const HomeStoreProviderManager = props => {
  const _isMounted = useRef(true)
  const { push } = useRoutes()
  const {
    authStore: { user }
  } = useAuthStore()
  const { standardCheck, silentCheck } = useResErrors()
  const [selectedTab, setSelectedTab] = useStateCallback(0)
  const [branchList, setBranchList] = useState([])
  const [seoActive, setSeoActive] = useState(false)
  const userBranchCode = user.data.branch.code
  const userRole = user.role

  useEffect(() => {
    getBranchList()
    haveActiveSale()
    getActiveSeo()
    return () => {
      _isMounted.current = false
    }
  }, [])

  const getBranchList = async () => {
    await AuthService.getBranches().then(res =>
      standardCheck(
        res,
        res => {
          setBranchList(res.data)
        },
        {
          textErr: 'Branch not found'
        }
      )
    )
  }

  const onChangeTab = (_, newValue) => {
    setSelectedTab(newValue, () => {})
  }

  const haveActiveSale = async () => {
    await SalesService.getActiveSales().then(res =>
      silentCheck(
        res,
        () => {
          if (res.data?.id) {
            const sale = res.data
            const step = res.data.selectedCarsForSale?.[0]
              ? 3
              : getPrevStepByStatus(
                  sale?.saleStatus?.code,
                  sale?.saleStatusTrack?.trackStatus?.code
                )

            push(
              SELECTION_STEP_PATH_LOADED(sale.id)[
                res.data?.isNewSeo ? NEW_SEO : step
              ]
            )
          }
        },
        {
          onFail: () => {
            //push(HOME_PATH)
          }
        }
      )
    )
  }

  const getActiveSeo = async () => {
    if (userRole === MANAGER_AUTO_DAMU) return setSeoActive(false)
    await SalesService.getActiveSeo().then(res =>
      silentCheck(
        res,
        () => {
          const activeIn = res.data?.split(',') || []
          setSeoActive(activeIn.includes(userBranchCode))
        },
        {
          onFail: () => {}
        }
      )
    )
  }

  const homeStore = {
    selectedTab,
    branchList,
    seoActive
  }

  const homeStoreFunc = { onChangeTab, haveActiveSale, getActiveSeo }

  const returnContextByTab = () => {
    if (selectedTab === 0) {
      return (
        <TaskStoreProviderManager homePrData={{ homeStore, homeStoreFunc }}>
          {props.children}
        </TaskStoreProviderManager>
      )
    }

    if (selectedTab === 1) {
      return (
        <SelectionStoreProviderManager
          homePrData={{ homeStore, homeStoreFunc }}
        >
          {props.children}
        </SelectionStoreProviderManager>
      )
    }

    if (selectedTab === 2) {
      return (
        <WorkListStoreProviderManager homePrData={{ homeStore, homeStoreFunc }}>
          {props.children}
        </WorkListStoreProviderManager>
      )
    }

    if (selectedTab === 3) {
      return (
        <BonusStoreProviderManager homePrData={{ homeStore, homeStoreFunc }}>
          {props.children}
        </BonusStoreProviderManager>
      )
    }

    return props.children
  }

  return (
    <HomeStoreContext.Provider value={{ homeStore, homeStoreFunc }}>
      {returnContextByTab()}
    </HomeStoreContext.Provider>
  )
}

export default withAuthStore(HomeStoreProviderManager)
